import { Button } from '../Button/Button';
import type { ButtonProps, ButtonComponentType } from '../Button/Button';

type TagProps<T extends ButtonComponentType = 'button'> = Omit<
  ButtonProps<T>,
  'variant'
>;

export const Tag = <T extends ButtonComponentType = 'button'>(
  props: TagProps<T>
) => {
  // @ts-expect-error react types...
  return <Button variant="contained" {...props} />;
};
